<template>
  <div class="salary-rules__rule-container">
    <h4 class="text-explainer" style="margin-top: 0" v-if="rules.length === 0">Ingen regler oprettet</h4>
    <draggable v-model="rules" @change="onChangeOrder" class="salary-rules__rule-container__draggable">
      <transition-group type="transition" name="flip-list" tag="ul">
        <li v-for="(rule, key) in rules" :key="rule.id" class="salary-rules__rule">
          <div>{{ key + 1 }}</div>
          <div>
            Hvis
          </div>
          <div>
            <select v-model="rule.type" @change="onChangeRuleType(rule, $event.target.value)">
              <option v-for="ruleType in ruleTypes" :value="ruleType.value">
                {{ ruleType.title }}
              </option>
            </select>
          </div>
          <div v-if="rule.type === 'employment_type'">
            <select v-model="rule.substituted_employment_title" @change="onChange">
              <option v-for="employmentsType in employmentsTypesForFullTime" :value="employmentsType">
                {{ employmentsType }}
              </option>
            </select>
          </div>
          <div v-if="rule.type === 'subject_type'">
            <select v-model="rule.subject_type" @change="onChange">
              <option v-for="subjectType in subjectTypes" :value="subjectType.value">
                {{ subjectType.name }}
              </option>
            </select>
          </div>
          <div v-if="rule.type === 'subject_title'">
            <input type="text" class="rule-input-text" :ref="'subjectTitleInput' + rule.id"
                   v-model.trim="rule.subject_title" @keyup="onChange"/>
          </div>
          <div v-if="rule.type === 'calendar_id'">
            <select v-model="rule.calendar_id" @change="onChange">
              <option v-for="calendar in calendars" :value="calendar.id">
                {{ calendar.name }}
              </option>
            </select>
          </div>
          <div>skal det tælle som</div>
          <div>
            <select class="do-select" v-model="rule.selected_employment_title" @change="onChange">
              <option v-for="employmentsType in employmentToSelectForRules" :value="employmentsType">
                {{ employmentsType }}
              </option>
            </select>
          </div>
          <div class="icon__bg-circle d-item-delete icon__bg-circle--danger"
               :content="$t('vue2.common.delete')"
               v-tippy="{
                    arrow: true,
                    placement : 'left'
                  }"
               @click="setRoleToDelete(rule)">
            <span class="icon-bin"></span>
          </div>
        </li>
      </transition-group>
    </draggable>
    <div class="do-buttons">
      <button class="btn-trans" @click.stop="addNewRule">+ Tiløj regel</button>
      <div class="do-submit-buttons" v-if="isChangeHasBeenMade">
        <button @click="submit" class="do-bttn do-bttn--submit" :class="{'do-bttn--submit--loading': isSaving}">
          {{ $t('vue2.common.save') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import docendo from '../../../docendo'
import eventbus from '../../../eventbus'

const SUBJECTTYPES = ['subject', 'supplemental', 'additional_tasks', 'optional', 'frame', 'break', 'resource', 'person_resource', 'preparation', 'club']

export default {
  name: 'SalaryRules',
  components: {draggable},
  props: {
    propRules: {
      type: Array,
      default: null
    },
    schoolSubstituteRules: {
      type: Object,
      default: null
    },
    schoolIds: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      isSaving: false,
      isConfirmDeletion: false,
      isChangeHasBeenMade: false,
      rules: [],
      ruleTypes: [
        {
          id: 1,
          value: 'employment_type',
          title: 'man er vikar for',
          prop: 'substituted_employment_title'
        },
        {
          id: 2,
          value: 'subject_type',
          title: 'briktypen er',
          prop: 'subject_type'
        },
        {
          id: 3,
          value: 'subject_title',
          title: 'brikken hedder',
          prop: 'subject_title'
        },
        {
          id: 4,
          value: 'calendar_id',
          title: 'kalenderen er',
          prop: 'calendar_id'
        }
      ]
    }
  },
  computed: {
    calendars () {
      return []
        .concat(this.klassCalendars)
        .concat(this.otherCalendars)
        .concat(this.clubCalendars)
    },
    klassCalendars () {
      return this.$store.getters.klassCalendars
    },
    clubCalendars () {
      return this.$store.getters.clubCalendars
    },
    otherCalendars () {
      return this.$store.getters.otherCalendars
    },
    locale () {
      return this.$store.getters.locale
    },
    school () {
      return this.$store.state.activeSchool
    },
    schoolId () {
      return this.$store.getters.schoolId
    },
    employmentTypesActive () {
      return this.$store.getters.employmentTypesActive
    },
    employmentToSelectForRules () {
      return this.$store.getters.employmentToSelectForRules
    },
    employmentsTypesForFullTime () {
      return this.employmentTypesActive.filter(employmentType => employmentType)
    },
    subjectTypes () {
      return SUBJECTTYPES.map(subjectType => {
        return {
          value: subjectType,
          name: this.$t('vue2.eventTypes.' + subjectType) !== 'vue2.eventTypes.' + subjectType
            ? this.$t('vue2.eventTypes.' + subjectType) : subjectType
        }
      })
    }
  },
  methods: {
    onChange () {
      this.isChangeHasBeenMade = true
    },
    validateArray (arr) {
      if (!Array.isArray(arr)) {
        return false // Sikre at input er et array
      }

      for (const obj of arr) {
        // Tjekker at obj er et objekt og ikke null
        if (obj && typeof obj === 'object' && !Array.isArray(obj)) {
          for (const key in obj) {
            if (obj[key] === null || obj[key] === '') {
              return false // Hvis en prop er null, returner false
            }
          }
        } else {
          return false // Hvis elementet ikke er et objekt, returner false
        }
      }
      return true // Alle objekter er valide, eller arrayet er tomt
    },
    onChangeRuleType (rule, val) {
      const ruleTypeProp = this.ruleTypes.find(ruleType => ruleType.value === val)['prop']
      const idxOfRule = this.rules.findIndex(rulesRule => rulesRule.id === rule.id)
      delete this.rules[idxOfRule]['subject_type']
      delete this.rules[idxOfRule]['substituted_employment_title']
      delete this.rules[idxOfRule]['calendar_id']
      delete this.rules[idxOfRule]['subject_title']
      this.rules[idxOfRule][ruleTypeProp] = null
      this.onChange()

      this.$nextTick(() => {
        if (val === 'subject_title') {
          // Brug dynamisk ref baseret på rule.id
          const inputRef = this.$refs['subjectTitleInput' + rule.id]
          if (inputRef) {
            inputRef[0].focus() // Sæt fokus på input-feltet
          }
        }
      })
    },
    setRoleToDelete (rule) {
      const idx = this.rules.findIndex(item => item.id === rule.id)
      if (idx > -1) {
        this.rules.splice(idx, 1)
      }
      this.onChange()
    },
    onChangeOrder () {
      this.onChange()
    },
    addNewRule () {
      const newRuleObj = {
        id: this.generateUUID(),
        type: 'employment_type',
        substituted_employment_title: null,
        selected_employment_title: null
      }
      this.rules.push(newRuleObj)
      this.onChange()
    },
    submit () {
      if (!this.validateArray(this.rules)) {
        eventbus.toast = {text: 'En regel må ikke indeholde tomme værdier', success: false}
        return
      }

      this.isSaving = true

      // Start med en dyb kopi af eksisterende regler
      let dbRules = JSON.parse(JSON.stringify(this.schoolSubstituteRules))

      // Hvis der er nogle `propRules` der starter med "_extra_time", filtrer dem
      const extraTimeRules = this.propRules ? this.propRules.filter(item => item.id.startsWith('_extra_time')) : []

      // Kombiner `this.rules` med `extraTimeRules`
      const combinedRules = [...extraTimeRules, ...this.rules]

      if (!combinedRules || combinedRules.length === 0) {
        delete dbRules.rules
      } else {
        dbRules['rules'] = combinedRules
      }

      this.$emit('changedMade')
      docendo.updateSchool(
        this.schoolId,
        {substitute_rules: dbRules},
        success => {
          eventbus.toast = {text: 'Gemt', success: true}
          this.isSaving = false
          this.isChangeHasBeenMade = false
          this.$store.commit('setActiveSchool', success)
          this.$store.commit('setSchoolSettings', success.custom_data)
        },
        failure => {
          console.log({failure})
        }
      )
    },
    cancel () {
      this.$emit('close')
    },
    generateUUID () {
      let d = new Date().getTime()
      let d2 = (window.performance && window.performance.now && (window.performance.now() * 1000)) || 0
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        let r = Math.random() * 16
        if (d > 0) {
          r = (d + r) % 16 | 0
          d = Math.floor(d / 16)
        } else {
          r = (d2 + r) % 16 | 0
          d2 = Math.floor(d2 / 16)
        }
        return (c === 'x' ? r : (r & 0x7 | 0x8)).toString(16)
      })
    }
  },
  mounted () {
    if (this.propRules) {
      this.rules = this.propRules.filter(item => !item.id.startsWith('_extra_time'))
    }
  }
}
</script>

<style scoped>

.salary-rules__rule-container {
  background: #f6f9fc;
  border: 1px solid #e2e8f0;
  padding: 2rem;
  border-radius: 4px;
}

.salary-rules__rule-container .salary-rules__rule-container__box {
  border: 1px solid #e2e8f0;
  padding: 1rem;
  border-radius: 4px;
}

.salary-rules__rule-container h4 {
  margin-bottom: 1rem;
}

.salary-rules__rule {
  position: relative;
  display: flex;
  margin-bottom: 0.5rem;
  align-items: center;
  gap: 1rem;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
  transition: transform .25s, background-color .25s, box-shadow .25s;
  cursor: move;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
}

.salary-rules__rule:hover {
  background-color: #f9fafc;
  transform: translateY(-2px);
  box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, .2);
}

.salary-rules__rule > div:first-child {
  padding: 1rem;
  background: #f6f7f8;
  border-radius: 4px 0 0 4px;
}

.salary-rules__rule-container select {
  box-shadow: 0 0 0 0 transparent, 0 0 0 0 transparent, 0 1px 1px 0 rgba(0, 0, 0, .12), 0 0 0 1px rgba(64, 68, 82, .16), 0 0 0 0 transparent, 0 0 0 0 transparent, 0 2px 5px 0 rgba(64, 68, 82, .08);
  border-radius: 4px;
  background-color: #fff;
  border: 0;
}

.do-buttons {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.do-submit-buttons {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  gap: 1rem;
}

.d-item-delete {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0.5rem;
}

.btn-trans {
  transition: transform 0.25s;
  width: 200px;
}

.btn-trans:hover {
  background: aliceblue;
}

.btn-trans:active {
  transform: scale(0.98);
}

.salary-rules__rule-container__draggable {
  margin-bottom: 1rem;
}

.rule-input-text {
  border-radius: 0 !important;
  border-width: 0 0 1px 0 !important;
  background: transparent !important;
}

</style>



// WEBPACK FOOTER //
// SalaryRule1.vue?6e5ec056